(() => {
  'use strict';
  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => [...root.querySelectorAll(s)];
  let lastTrigger;
  const open = (id, trigger) => {
    const dialog = document.getElementById(id);
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    $$('dialog[open]').forEach(d => d.close());
    lastTrigger = trigger;
    dialog.showModal();
    document.body.classList.add('a-modal-open');
    if (id === 'a-search') $('#a-query')?.focus();
    return true;
  };
  $$('dialog').forEach(dialog => {
    dialog.addEventListener('close', () => { document.body.classList.remove('a-modal-open'); lastTrigger?.focus(); });
    dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
  });
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-open]');
    if (trigger && open(trigger.dataset.open, trigger)) event.preventDefault();
    const close = event.target.closest('[data-close]');
    if (close) close.closest('dialog')?.close();
  });
  const query = $('#a-query');
  query?.addEventListener('input', () => {
    const term = query.value.trim().toLocaleLowerCase();
    let found = 0;
    $$('.a-search-item').forEach(item => { item.hidden = !item.dataset.searchTitle.includes(term); if (!item.hidden) found++; });
    $('[data-search-empty]').hidden = found > 0;
  });
  const catalog = $('[data-catalog]');
  if (catalog) {
    const cards = $$('.a-card', catalog), grid = $('[data-catalog-grid]', catalog);
    const filter = name => {
      let count = 0;
      cards.forEach(card => { card.hidden = name !== 'all' && card.dataset.category !== name; if (!card.hidden) count++; });
      $$('[data-filter]', catalog).forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === name)));
      $('[data-result-count]', catalog).textContent = count;
      const url = new URL(location.href); name === 'all' ? url.searchParams.delete('category') : url.searchParams.set('category', name); history.replaceState({}, '', url);
    };
    $$('[data-filter]', catalog).forEach(button => button.addEventListener('click', () => filter(button.dataset.filter)));
    const initial = new URL(location.href).searchParams.get('category');
    if (['signature', 'accessories', 'nftees'].includes(initial)) filter(initial);
    $('[data-sort]', catalog)?.addEventListener('change', event => {
      const sorted = [...cards];
      if (event.target.value !== 'default') sorted.sort((a,b) => (Number(a.dataset.price) - Number(b.dataset.price)) * (event.target.value === 'low' ? 1 : -1));
      sorted.forEach(card => grid.append(card));
    });
  }
  $$('[data-gallery-src]').forEach(button => button.addEventListener('click', () => {
    const main = $('.a-main-image'), zoom = $('.a-zoom-image');
    for (const image of [main, zoom]) if (image) { image.removeAttribute('srcset'); image.src = button.dataset.gallerySrc; image.alt = button.dataset.galleryAlt; }
    $$('[data-gallery-src]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
  }));
  const form = $('#a-product-form');
  form?.addEventListener('change', event => {
    if (event.target.name !== 'id') return;
    $$('[data-product-price]').forEach(price => { price.textContent = event.target.dataset.price; });
    const url = new URL(location.href); url.searchParams.set('variant', event.target.value); history.replaceState({}, '', url);
  });
  let busy = false;
  const responseJSON = async response => { const data = await response.json(); if (!response.ok) throw new Error(data.description || data.message || `Request failed (${response.status})`); return data; };
  const refreshBag = async () => {
    const url = new URL(document.body.dataset.cart, location.origin); url.searchParams.set('sections', 'atelier-bag');
    if (document.body.dataset.themeId && window.Shopify?.theme?.role === 'unpublished') url.searchParams.set('preview_theme_id', document.body.dataset.themeId);
    const sections = await responseJSON(await fetch(url, {headers:{Accept:'application/json'}}));
    let html = sections['atelier-bag'];
    if (!html) {
      url.searchParams.delete('sections');
      const page = await fetch(url, {headers:{Accept:'text/html'}});
      if (!page.ok) throw new Error(`Request failed (${page.status})`);
      const documentCopy = new DOMParser().parseFromString(await page.text(), 'text/html');
      html = documentCopy.querySelector('[data-cart-page-content]')?.innerHTML;
      if (!html) throw new Error('Unable to refresh bag. Please reload the bag page.');
    }
    $$('[data-bag-content],[data-cart-page-content]').forEach(container => { container.innerHTML = html; });
    const count = $('[data-cart-state]')?.dataset.count || '0';
    $$('[data-cart-count]').forEach(el => { el.textContent = count; });
  };
  form?.addEventListener('submit', async event => {
    event.preventDefault(); if (busy) return; busy = true;
    const button = $('.a-add', form), sticky = $('[data-sticky-add]'), error = $('[data-product-error]', form);
    button.disabled = true; if (sticky) sticky.disabled = true;
    button.textContent = button.dataset.loadingLabel; error.hidden = true;
    try {
      await responseJSON(await fetch(`${document.body.dataset.cartAdd}.js`, {method:'POST',body:new FormData(form),headers:{Accept:'application/json'}}));
      try { await refreshBag(); open('a-bag', button); } catch { location.assign(document.body.dataset.cart); }
    } catch (e) { error.textContent = e.message; error.hidden = false; }
    finally { busy = false; button.disabled = false; if (sticky) sticky.disabled = false; button.textContent = `${button.dataset.addLabel} ↗`; }
  });
  const change = async (key, quantity, trigger) => {
    if (busy || !Number.isInteger(quantity) || quantity < 0) return; busy = true;
    const state = trigger.closest('[data-cart-state]'); state?.setAttribute('aria-busy','true');
    const error = $('[data-cart-error]', state || document); if (error) error.hidden = true;
    try {
      await responseJSON(await fetch(`${document.body.dataset.cartChange}.js`, {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity})}));
      await refreshBag();
      $('.a-dialog-head button', $('#a-bag'))?.focus();
    } catch (e) { if (error) { error.textContent = e.message; error.hidden = false; } }
    finally { busy = false; state?.removeAttribute('aria-busy'); }
  };
  document.addEventListener('click', event => { const button = event.target.closest('button[data-cart-key]'); if (button) change(button.dataset.cartKey,Number(button.dataset.quantity),button); });
  document.addEventListener('change', event => { if (event.target.matches('input[data-cart-key]')) change(event.target.dataset.cartKey,Number(event.target.value),event.target); });
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  if ('IntersectionObserver' in window && !reduced) {
    const observer = new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('a-in-view'); observer.unobserve(entry.target); } }), {threshold:0.12});
    $$('[data-reveal]').forEach(el => { el.classList.add('a-reveal-ready'); observer.observe(el); });
  }
  if (form && 'IntersectionObserver' in window) new IntersectionObserver(entries => { $('.a-sticky-buy')?.classList.toggle('a-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0); }, {threshold:0}).observe(form);
  document.addEventListener('shopify:section:load', () => location.reload());
})();
